import productApi from '@/service/modules/productApi';
import systemApi from '@/service/modules/systemApi';
import { Button, Modal, Form, Input, Checkbox, message, Image } from 'antd';
import { useEffect, useRef, useState } from 'react';
// @ts-ignore
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  onClose: Function;
  isWholesaleOpen: boolean;
  productID: number | undefined;
  goodsName?: string | undefined
}

export default function NotifyMe({ onClose, isWholesaleOpen, productID, goodsName }: Props) {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const [siteKey, setSiteKey] = useState('')
  const [recaptchaToken, setRecaptchaToken] = useState('');

  useEffect(() => {
    // generate()
    getRecaptchaSiteKey()
  }, [])

  const getRecaptchaSiteKey = async () => {
    try {
      let res = await systemApi.getRecaptchaSiteKey()
      if (res.data && res.data.siteKey) {
        setSiteKey(res.data.siteKey)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleRecaptchaChange = (value: string | null) => {
    setRecaptchaToken(value || '')
  };

  const defaultCaptcha = {
    img: "",
    key: ""
  }
  const [captcha, setCaptcha] = useState(defaultCaptcha)
  const generate = async () => {
    try {
      const res = await productApi.generate()
      const { captcha } = res.data
      setCaptcha(captcha)

    } catch (error: any) {
      message.error(error.message)

    }
  }

  const [btnLoading, setBtnLoading] = useState(false)

  const onFinish = async (values: any) => {
    const recaptcha = recaptchaRef.current?.getValue();
    if (!siteKey || !recaptcha) {
      message.error('Please verify you are not a robot')
      return
    }
    setBtnLoading(true)
    const params = {
      ...values,
      newsletter: values.newsletter ? 1 : 0,
      recaptcha,
      productID
    }
    try {
      await productApi.addNotify(params)
      setBtnLoading(false)
      onClose()
      message.success("Success")

    } catch (error: any) {
      setBtnLoading(false)
      generate()
      message.error(error.message)
    }
  };

  type FieldType = {
    userName?: string;
    email?: string;
    newsletter?: boolean;
  };

  return (
    <Modal
      title=""
      centered
      open={isWholesaleOpen}
      onOk={() => onClose()}
      onCancel={() => onClose()}
      footer={null}
      width={513}
    >
      <div style={{ margin: "0 auto" }}>
        <h2 style={{ color: "#446CB3", fontWeight: "bold", fontSize: "24px", margin: "27px 0 0", textAlign: 'center' }}>Notify me when the item is available!</h2>
        <p style={{ color: "#333333", fontWeight: "bold", fontSize: "14px", margin: "27px 0" }}>
          {`Please fill out the information below and you will be notified as soon as the item below becomes available.`}<br />
          {`Unfortunately, we aren't able to advise on ETAs for our products, as
					we often usually restock items at very short notice, due to
					wholesaler clearances. However, you'll be the first to know if you
					register for this email alert! ${goodsName}`}
        </p>
        <Form
          name="wholesale"
          layout="horizontal"
          labelAlign="left"
          labelCol={{ flex: '200px' }}
          labelWrap
          onFinish={onFinish}
        >
          <Form.Item<FieldType>
            name="userName"
            rules={[{ required: true, message: 'please input your name' }]}
          >
            <Input placeholder='Name' />
          </Form.Item>

          <Form.Item<FieldType>
            name="email"
            rules={[{ required: true, message: "please input your email" }, { type: "email" }]}
          >
            <Input placeholder="Email" />
          </Form.Item>

          {
            !!(siteKey) &&
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={siteKey}
              type={'audio'}
              onChange={handleRecaptchaChange}
            />
          }
          <br />
          <Form.Item
            name="newsletter"
            valuePropName="checked"
          >
            <Checkbox>
              I would like to receive your Newsletter to be the first to know about hot offers!
            </Checkbox>
          </Form.Item>


          <Form.Item>
            <Button loading={btnLoading} htmlType="submit" style={{ width: "100%", height: "40px", backgroundColor: '#446CB3', textAlign: 'center', color: '#fff', borderRadius: '0', padding: "0" }}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}